<!--
  Copyright 2020 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="header">
  <div>
    <ng-content select="[beginning]"></ng-content>
    <img
      class="logo"
      src="/assets/img/logo.svg"
      (click)="onSurveysButtonClick()"
    />
    <span class="ground-title">Ground</span>
    <ng-content select="[left]"></ng-content>
  </div>

  <div>
    <ng-container *ngIf="canManage">
      <ng-container *ngIf="canManage && state === HeaderState.MAP_VIEW">
        <button mat-icon-button [matMenuTriggerFor]="editSurveyMenu">
          <mat-icon fontSet="material-symbols-outlined">settings</mat-icon>
        </button>

        <div class="header-divider"></div>
      </ng-container>

      <mat-menu #editSurveyMenu="matMenu">
        <a (click)="onEditSurveyClick()">
          <button mat-menu-item>Manage survey</button>
        </a>
      </mat-menu>

      <ng-container *ngIf="state === HeaderState.EDIT_SURVEY">
        <button
          mat-button
          class="cancel-edit-button"
          (click)="onCancelEditSurveyClick()"
        >
          Cancel
        </button>

        <button
          mat-flat-button
          class="finish-edit-button"
          [disabled]="isPublishingChanges || !isDraftSurveyDirtyAndValid()"
          (click)="onFinishEditSurveyClick()"
        >
          Publish changes
          <mat-icon *ngIf="isPublishingChanges">
            <mat-spinner diameter="18"></mat-spinner>
          </mat-icon>
        </button>

        <div class="header-divider"></div>
      </ng-container>
    </ng-container>

    <button mat-icon-button [matMenuTriggerFor]="infoMenu">
      <mat-icon fontSet="material-symbols-outlined">info_outline_24px</mat-icon>
    </button>

    <mat-menu #infoMenu="matMenu">
      <a (click)="onTermsOfServiceClick()">
        <button mat-menu-item>Terms of service</button>
      </a>

      <a (click)="onAboutClick()">
        <button mat-menu-item>About</button>
      </a>
    </mat-menu>

    <ground-current-user-widget></ground-current-user-widget>
  </div>
</div>
